import React, { useState } from 'react';
import { API_BASE_URL } from '../configs/apiConfig';
import NoImageProfile from '../assets/images/No-Image-Profile.png';

const ProfileImage = ({ 
  imageUrl, 
  width, 
  height, 
  className = "rounded-circle", 
  alt = "Profile", 
  onClick,
  style
}) => {
  const [imageError, setImageError] = useState(false);

  // Handle image loading error
  const handleError = () => {
    setImageError(true);
  };

  // Determine the source URL
  const getSrc = () => {
    if (imageError || !imageUrl) {
      return NoImageProfile;
    }

    // If the URL is already absolute, use it directly
    if (imageUrl.startsWith('http') || imageUrl.startsWith('data:')) {
      return imageUrl;
    }

    // Otherwise, prepend the API base URL
    // Remove leading slash from imageUrl and trailing slash from API_BASE_URL if present
    const cleanImageUrl = imageUrl.replace(/^\//, '');
    const cleanBaseUrl = API_BASE_URL.replace(/\/$/, '');
    return `${cleanBaseUrl}/${cleanImageUrl}`;
  };

  // If width and height are not provided, use container-based sizing
  const imageStyle = {
    objectFit: 'cover',
    width: width ? `${width}px` : '100%',
    height: height ? `${height}px` : '100%',
    ...style
  };

  return (
    <img
      src={getSrc()}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={handleError}
      style={imageStyle}
    />
  );
};

export default ProfileImage; 